import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Divider,
  TextField,
  Button,
  IconButton,
  Grid,
  CircularProgress,
} from "@mui/material";
import Noimage from "../../../../Image/No.png";
import signImages from "../../../../Image/sign.png";
import CloseIcon from "@mui/icons-material/Close";
import signsuccess from "../../../../Image/signsuccess.png"; 
import { Dialog as ConfirmDialog, DialogActions as ConfirmDialogActions, DialogContent as ConfirmDialogContent, DialogTitle as ConfirmDialogTitle } from "@mui/material";
import Swal from "sweetalert2";

interface SignModalProps {
  open: boolean;
  onClose: () => void;
  onSign: (comment: string) => void;
}

const SignModal: React.FC<SignModalProps> = ({ open, onClose, onSign }) => {
  const [comment, setComment] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [isLoading, setLoading] = useState(false); // สำหรับแสดงสถานะโหลด
  const maxCharacters = 100;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;

    if (inputValue.startsWith(" ")) {
      return;
    }

    if (inputValue.length <= maxCharacters) {
      setComment(inputValue);
      // console.log("ความคิดเห็น:", inputValue);
    }
  };

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
  };

  const handleSave = () => {
    onSign(comment);  
    handleOpenConfirmDialog();  
    setComment(""); 
    onClose(); 
    // console.log("ความคิดเห็นที่บันทึก:", comment);
  };

  const handleConfirmSave = () => {
    // console.log("บันทึกสำเร็จ");
    setLoading(true); 
    setOpenConfirmDialog(false);  

    setTimeout(() => {
      setLoading(false); 
      setOpenSuccessDialog(true);  
    }, 2000); 

    setTimeout(() => {
      setComment("");  
      setOpenSuccessDialog(false); 
    }, 4000); 
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "ระบบกำลังดำเนินการ",
        html: "กรุณารอสักครู่...",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  return (
    <>
      {/* SignModal */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          setComment(""); 
          onClose();
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            mx: 2,
            width: "500px",
          },
        }}
      >
        <Box sx={{ ml: 2 }}>
          <DialogTitle textAlign="center">
            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={Noimage} alt="รูปภาพ" style={{ width: 30, height: "auto", marginRight: 8 }} />
                <Typography variant="body1" sx={{ color: "#000", fontWeight: "bold" }}>
                  ลงนามลายเซ็นดิจิทัล
                </Typography>
              </Box>

              <IconButton onClick={() => { setComment(""); onClose(); }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Divider />
            </Box>
          </DialogTitle>

          <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={{ p: 1, color: "#000", fontSize: "14px" }}>ลายเซ็นดิจิทัล</Typography>
            <Box
              sx={{
                width: { xs: "94%", lg: "95%" },
                height: 200,
                backgroundColor: "#F3F9FF",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #99B9F3",
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1, mt: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1, mt: 2, width: "100%" }}>
                <Typography sx={{ color: "#000", fontSize: "14px" }}>ความคิดเห็น</Typography>
                <Typography sx={{ color: comment.length === maxCharacters ? "#D32F2F" : "grey.600", fontSize: "14px" }}>
                  {comment.length}/{maxCharacters}
                </Typography>
              </Box>
            </Box>

            <TextField
              variant="outlined"
              fullWidth
              multiline
              minRows={4}
              maxRows={6}
              placeholder="ระบุความคิดเห็น (ไม่จำเป็นต้องระบุ)"
              value={comment}
              onChange={handleChange}
              sx={{
                width: { xs: "95%", lg: "96%" },
                backgroundColor: "#fff",
                borderRadius: "16px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #C4C4C4",
                    borderRadius: "16px",
                  },
                  "&:hover fieldset": { borderColor: "#99B9F3" },
                  "&.Mui-focused fieldset": { borderColor: "#0288D1" },
                },
              }}
            />
          </DialogContent>

          <DialogActions>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Button
                onClick={handleSave}
                sx={{
                  mb:2,
                  padding: "6px 40px",
                  backgroundColor: "#0288D1",
                  color: "#fff",
                  borderRadius: "15px",
                  "&:hover": {
                    backgroundColor: "#0277BD",
                  },
                }}
              >
                บันทึก
              </Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>

      {/* Confirm Dialog */}
      <ConfirmDialog
        open={openConfirmDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseConfirmDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton onClick={handleCloseConfirmDialog} sx={{ position: "absolute", top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>

        <ConfirmDialogContent>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} display="flex" justifyContent="center">
              <img src={signImages} alt="รูปภาพ" style={{ width: 160, height: "auto", marginBottom: "20px" }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mt: -2, fontFamily: "Sarabun, sans-serif", textAlign: "center", color: "#333333", fontSize: "16px", fontWeight: "bold" }}>
                ต้องการยืนยันเซ็นเอกสาร
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mt: -1, fontFamily: "Sarabun, sans-serif", textAlign: "center", color: "#636363", fontSize: "14px" }}>
                ท่านต้องการยืนยันการเซ็นเอกสารหรือไม่
              </Typography>
            </Grid>
          </Grid>
        </ConfirmDialogContent>

        <ConfirmDialogActions>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button onClick={() => setOpenConfirmDialog(false)} variant="outlined" color="error" sx={{ mt: -1, width: "120px", height: "40px", borderRadius: "20px" }}>
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirmSave}
                variant="contained"
                sx={{
                  mt: -1,
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#0288D1" },
                }}
              >
                ยืนยัน
              </Button>
            </Grid>
          </Grid>
        </ConfirmDialogActions>
      </ConfirmDialog>

      {/* Success Dialog */}
      <Dialog
        open={openSuccessDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseSuccessDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signsuccess}
                alt="รูปภาพ"
                style={{
                  width: 280,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ยืนยันการเซ็นเอกสารสำเร็จ
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ทำการยืนยันเซ็นเอกสาร เรียบร้อยแล้ว
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SignModal;
